// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace config.
 *
 * @module js/swf3dWorkspaceConfig
 */

// Workspace toolkit config data.
var swf3dWorkspaceConfig = {
    // S3.
    bucket: '',
    region: '',
    accessKey: '',
    secretKey: '',

    clientId: '',
    jsessionId: '',

    // Workspace service host.
    url: '/galaxyWorkspace',

    // mode.
    storage: 's3',

    // resource type.
    resourceType: 'projects',

    // Authorization data.
    authorization: '',

    // Collab info.
    collabSpaceId: '',
    projectId: '',

    //
    baseUrn: '',

    // Zeus host.
    collabHost: '',
    dssHost: '',

    // Local workspace path.
    localPath: '',

    // Filter list.
    tableFilterList: [],

    // Preview host.
    previewHost: '',

    showPreview: false,

    validTypeList: [],

    // Application info.
    appInfo: {},

    ready: Promise.resolve(),

    tenantId: undefined,

    set: function (name, data) {
        swf3dWorkspaceConfig[name] = data;
    },
    get: function (name) {
        return swf3dWorkspaceConfig[name];
    }
};

export default swf3dWorkspaceConfig;
